module.exports = __webpack_public_path__ + "static/gtm_8-fd8e5ce9abe5e69cfaf1c791736243f5.png";